import { motion } from "framer-motion";
import clsx from "clsx";

interface RadioGroupSkeletonProps {
	columnsClass?: string;
	showIcons?: boolean;
	items?: number;
}

export const RadioGroupSkeleton = ({
	columnsClass = "jF-grid-cols-2",
	showIcons = false,
	items = 8,
}: RadioGroupSkeletonProps) => {
	return (
		<motion.div
			layout
			initial={{ height: 0, opacity: 0 }}
			animate={{ height: "auto", opacity: 1 }}
			exit={{ height: 0, opacity: 0 }}
			transition={{ duration: 0.3, ease: "easeInOut" }}
			style={{ overflow: "hidden" }}
			aria-busy="true"
		>
			{/* Label */}
			<div className="jF-h-6 jF-w-32 jF-rounded jF-bg-gray-200 jF-animate-pulse" />

			{/* Grid */}
			<div
				className={clsx(
					columnsClass,
					"jF-grid jF-mt-1 jF-gap-x-2 jF-gap-y-2 md:jF-gap-x-2"
				)}
				style={{ gridAutoRows: "1fr" }}
			>
				{Array.from({ length: items }).map((_, i) => (
					<div
						key={i}
						className="jF-relative jF-flex jF-h-full jF-rounded-lg jF-border jF-border-gray-300 jF-bg-white jF-p-2 md:jF-p-3"
					>
						<div className="jF-flex jF-flex-col jF-justify-center jF-gap-2 jF-flex-1">
							{showIcons && (
								<>
									<div className="jF-h-12 jF-w-6 jF-rounded jF-bg-gray-200 jF-animate-pulse" />
								</>
							)}

							<div className="jF-h-10 jF-w-3/4 jF-rounded jF-bg-gray-200 jF-animate-pulse" />
						</div>
					</div>
				))}
			</div>
		</motion.div>
	);
};
